import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { error } from '../../constants/bindings';
import AcDialogInterface from '../../models/AcDialogInterface';
import { useApiError } from '../../providers/ApiErrorProvider';
import { useAuth } from '../../providers/Auth';
import AcDialog from '../AcDialog/AcDialog';


export default function AcErrorDialog({errorCode}) {
  const { t } = useTranslation();
  const user = useAuth();
  const history = useHistory();
  const {setErrorCode} = useApiError();
  
  const [open, setOpen] = useState(true);
  const handleClose = () => setOpen(false);

  // const handleLogout = () => {
  //   user.signOut();
  // }

  const handleReturnToLogin = () => {
    setErrorCode(0);
    handleClose();
    history.push('/login');
  }

  const handleReturnToHomepage = () => {
    setErrorCode(0);
    handleClose();
    history.push('/');
  }
 

  const handleRefresh = () => {
    window.location.reload();
  }

  const handleLogin = () => {
    localStorage.clear();
    user.signIn()
  }

  const defaultErrorData: AcDialogInterface = {
    icon: 'icon-sad-emoji',
    title: t('errorDefault.title'),
    description: t('errorDefault.description'),
    actionLabel: t('errorDefault.buttonText'),
    handleAction: handleReturnToHomepage,
    secondaryActionLabel:t('errorDefault.secondaryButtonText'),
    handleSecondaryAction: handleRefresh
  }

  const authErrorData: AcDialogInterface = {
    title: t('errorAuth.title'),
    description: t('errorAuth.description'),
    actionLabel: t('errorAuth.buttonText'),
    handleAction: handleLogin
  }

  const timeoutErrorData: AcDialogInterface = {
    icon: 'icon-sad-emoji',
    title: t('errorTimeout.title'),
    description: t('errorTimeout.description'),
    support: t('errorTimeout.support'),
    actionLabel: t('errorTimeout.buttonText'),
    handleAction: handleRefresh
  }

  const profileErrorData: AcDialogInterface = {
    icon: 'icon-sad-emoji',
    title: t('profileError.title'),
    description: t('profileError.description'),
    support: t('profileError.support'),
    actionLabel: '',
    secondaryActionLabel: t('profileError.buttonText'),
    handleSecondaryAction: handleReturnToLogin
  }

  const networkErrorData: AcDialogInterface = {
    icon: 'icon-sad-emoji',
    title: t('errorNetwork.title'),
    description: t('errorNetwork.description'),
    actionLabel: t('errorNetwork.buttonText'),
    handleAction: handleReturnToHomepage,
    secondaryActionLabel: t('errorDefault.secondaryButtonText'),
    handleSecondaryAction: handleRefresh
  }

  const getData = () =>{
      if(errorCode === error.AUTH || errorCode === error.FORBIDDEN) {
          return authErrorData
      } else if(errorCode === error.TIME_OUT) {
          return timeoutErrorData
      } else if(errorCode === error.ERR_5012) {
        return profileErrorData
      } else if (errorCode === error.NETWORK) {
        return networkErrorData
      }
      else {
          return defaultErrorData
      }
  }

  return (
    <>
        <AcDialog open={open} onClose={handleClose} data={getData()} />
    </>
  );
}
